<template>
  <div class="content">
    <div class="Tabs">

      <b-tabs card v-model="tabIndex">
        <b-tab :title="lang.tab_Details" :title-link-class="textColors" :title-item-class="textColors"
          :active="tabIndex == 0">

          <span v-if="distributorPartId!=undefined">
            <SearchedDetailsPropTableComponent :lang="lang.PropertiesDetails"></SearchedDetailsPropTableComponent>
            <SearchedDetailsAvailabilityTableComponent :lang="lang.AvailabilityDetails" place="search">
            </SearchedDetailsAvailabilityTableComponent>
            <SearchedDetailsPriceTableComponent :lang="lang.PriceDetails"></SearchedDetailsPriceTableComponent>

            <div>
              <hr>
              <label for="endoflife-datepicker">{{ lang.label_EndOfLife }}:</label>
              <b-form-datepicker :disabled="currentUser.role == 'Reader'" id="endoflife-datepicker" v-model="endoflife"
                :state="endoflifeState" size="sm" class="mb-1"></b-form-datepicker>
              <label for="endofsale-datepicker">{{ lang.label_EndOfSale }}:</label>
              <b-form-datepicker :disabled="currentUser.role == 'Reader'" id="endofsale-datepicker" v-model="endofsale"
                :state="endofsaleState" size="sm" class="mb-1"></b-form-datepicker>
              <label for="comment-textarea">{{ lang.label_Comment }}:</label>
              <b-form-textarea id="comment-textarea" class="item-form comment-textarea mb-1" :rows="6" v-model="comment"
                :disabled="currentUser.role == 'Reader'" size="sm">
              </b-form-textarea>
              <b-button v-if="currentUser.role != 'Reader'" @click="endofpart" :variant="variant" size="sm"
                class="btn button-update">{{ lang.button_Update }}
              </b-button>

            </div>
            <div v-if="globalSettings.SEDetails">
              <hr>
              <SearchedSEDetailsTableComponent :lang="lang.SEDetails" parent="partSearched">
              </SearchedSEDetailsTableComponent>

            </div>
          </span>
          <span v-else>
            {{lang.infotext_1}}
          </span>


        </b-tab>
        <b-tab v-if="currentUser.role != 'Reader'" :title="lang.tab_Search" :title-link-class="textColors"
          :title-item-class="textColors" :active="tabIndex == 1">

          <SearchComponent :lang="lang.Search" parent="PartSearch"></SearchComponent>

        </b-tab>

        <b-tab :title="lang.tab_SelectedPart" :title-link-class="textColors" :title-item-class="textColors"
          :active="tabIndex == 2">
          <p v-if="!isSelectedPart">{{lang.infotext_2}}</p>
          <QuickViewTableComponent v-if="isSelectedPart" :lang="lang.QuickView" parent="Search">
          </QuickViewTableComponent>

        </b-tab>
        <b-tab :title="lang.tab_WhereUsedPhysicals" :title-link-class="textColors" :title-item-class="textColors" :active="tabIndex == 3">

          <WhereUsedPhysicalsComponent :lang="lang.WhereUsedPhysicals"></WhereUsedPhysicalsComponent>

        </b-tab>
      </b-tabs>

    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import SearchComponent from '@/components/shared/SearchComponent'
import SearchedDetailsPropTableComponent from '@/components/shared/SearchedDetailsPropTableComponent'
import SearchedDetailsPriceTableComponent from '@/components/shared/SearchedDetailsPriceTableComponent'
import SearchedDetailsAvailabilityTableComponent from '@/components/shared/SearchedDetailsAvailabilityTableComponent'
import QuickViewTableComponent from '@/components/shared/QuickViewTableComponent'
import WhereUsedPhysicalsComponent from '@/components/shared/WhereUsedPhysicalsComponent'
import SearchedSEDetailsTableComponent from '@/components/shared/SearchedSEDetailsTableComponent'

//import TasksTableComponent from '@/components/shared/TasksTableComponent'

export default {
  name: "Content",
  components: {

    SearchComponent,
    SearchedDetailsPropTableComponent,
    SearchedDetailsPriceTableComponent,
    SearchedDetailsAvailabilityTableComponent,
    QuickViewTableComponent,
    WhereUsedPhysicalsComponent,
    SearchedSEDetailsTableComponent
  },
  props:{
    lang: Object
  },
  data () {
    return {
      tabIndex: 0,
      endoflife: null,
      endofsale: null,
      comment: "",
      endoflifeState: null,
      endofsaleState: null,

    }
  },
  computed: {
    ...mapGetters({
      selectedRows: 'selectedRows',
      globalSettings: "globalSettings",
      currentUser: 'currentUser'
    }),
    isSelectedPart(){
      return this.selectedRows.length != 0;
    },
    distributorPartId(){

      return this.$store.getters.selectedSearchedRows.DistributorPartId;

    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    variant() {
      if (this.$store.getters.s_skinVariant == "dark") {
        return "light";
      } else {
        return "dark";
      }

    },
  },
  created () {
    this.getTabIndex();
    

  },
  watch: {
    tabIndex: function (newVal) {

      let obj = {};
      obj[this.$route.path + "__right"] = newVal;

      this.$store.commit("SETTABDATA", obj);

      //####################
    },
    distributorPartId: function () {
      this.getPhysicalParam();
    }
  },
  methods: {
    getTabIndex() {
      

      if (this.$store.getters.tabData[this.$route.path + "__right"] != undefined) {
        this.tabIndex = this.$store.getters.tabData[this.$route.path + "__right"];
      } else {
        this.tabIndex = 0;
      }

    },
    getPhysicalParam() {

      let vue = this;

      const obj = {
        distributorPartId: this.distributorPartId
      }

      this.$store.dispatch("getPhysicalParam", obj)
        .then((result) => {
          console.log(result.data)

          if (result.data[0] != undefined) {
            vue.endoflife = result.data[0].endOfLife;
            vue.endofsale = result.data[0].endOfSale;
            vue.comment = result.data[0].comment;
          }
          
          vue.checkDateEndOfParts();


        })
    },
    endofpart() {

      let _vue = this;

      const obj = {
        distributorPartId: this.distributorPartId,
        params: {
          endOfLife: this.endoflife,
          endOfSale: this.endofsale,
          comment: this.comment
        }
        
      }

      this.$store.dispatch("pm_updatePhysicalParam", obj)
        .then((result) => {

          if (result.data == 1) {

            _vue.checkDateEndOfParts();

            const obj = {
              text: _vue.lang.alert_success_updateAlternative,
              time: 5,
              type: "success"
            }

            _vue.$store.dispatch("displayFooterAlert", obj);
          } else {

            const obj = {
              text: _vue.lang.alert_error_updateAlternative,
              time: 15,
              type: "danger"
            }

            _vue.$store.dispatch("displayFooterAlert", obj);
          }

        })


    },
    checkDateEndOfParts() {

      const now = new Date();
      const oneDay = 1000 * 60 * 60 * 24;


     
      if (this.endoflife != null) {
        const endoflifeDate = new Date(this.endoflife)
        const diffInTimeA = endoflifeDate.getTime() - now.getTime();
        const diffInDaysA = Math.round(diffInTimeA / oneDay);
        
        if (diffInDaysA < 365) {
          this.endoflifeState = false;
        } else {
          this.endoflifeState = true;
        }
      } else {
        this.endoflifeState = null;
      }

      if (this.endofsale != null) {

        const endofsaleDate = new Date(this.endofsale)
        const diffInTimeB = endofsaleDate.getTime() - now.getTime();
        const diffInDaysB = Math.round(diffInTimeB / oneDay);

        if (diffInDaysB < 365) {
          this.endofsaleState = false;
        } else {
          this.endofsaleState = true;
        }
      } else {
        this.endofsaleState = null;
      }
    },
  }
}
</script>

<style lang="scss">

  .Tabs{

    .bv-example-row-max{
      max-width: 100%;
      padding-right: 0px;
      padding-left: 0px;
    }
    .comment-textarea {
      height: 90px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/PartSearch/Right/Content/Content.vue